import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

interface NavTabsProps {
  tabs: { label: string; path: string }[];
  className?: string;
}

const NavTabs: React.FC<NavTabsProps> = ({ tabs, className = "" }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleTabClick = (path: string) => {
    navigate(path);
  };

  const isActiveTab = (path: string) => {
    const currentFullPath = location.pathname + location.search;
    if (!path.includes('?')) {
      return location.pathname === path && !location.search;
    }
    return currentFullPath === path;
  };

  return (
    <div className={`mb-8 ${className}`}>
      <div className="flex gap-4">
        {tabs.map((tab) => (
          <button
            key={tab.label}
            onClick={() => handleTabClick(tab.path)}
            className={`px-6 py-3 rounded-lg font-medium text-sm transition-all ${
              isActiveTab(tab.path)
                ? 'bg-blue-500 text-white shadow-md'
                : 'bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 hover:text-gray-800 dark:hover:text-white'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default NavTabs;